<vs-dialog #dialog [config]="{ dialogContainerClass: 'max-w-[600px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      icon: 'users-01',
      iconTheme: 'primary',
      title: party ? 'Edit Party' : 'Add Party',
      subtitle: 'A counterparty rating-matrix fees can be attributed to.'
    }"
  ></vs-dialog-header>

  <vs-form-field
    appearance="responsive"
    [config]="{ label: 'Name', description: 'Captured onto contract components at issuance — renaming never changes issued contracts.' }"
  >
    <input vsInput type="text" placeholder="e.g. AmTrust" [(ngModel)]="name" />
  </vs-form-field>

  <vs-divider class="my-4"></vs-divider>

  <div class="flex flex-col gap-3">
    <div>
      <div class="text-sm font-medium text-gray-700">Roles</div>
      <div class="text-sm text-gray-600">The roles this party can receive fees in. One party can hold several.</div>
    </div>

    <div *ngFor="let option of roleOptions" class="flex gap-4">
      <input
        vsInput
        type="checkbox"
        appearance="toggle"
        [id]="'party-role-' + option.role"
        [checked]="roles.has(option.role)"
        (change)="toggleRole(option.role, $any($event.target).checked)"
      />
      <div class="flex flex-col">
        <label [for]="'party-role-' + option.role" class="text-sm font-medium text-gray-700">{{ option.label }}</label>
        <label [for]="'party-role-' + option.role" class="text-sm text-gray-600">{{ option.description }}</label>
        <span *ngIf="isRoleInUse(option.role) && !roles.has(option.role)" class="text-xs text-warning-600">
          This party is still assigned to fee types or cells — removing a role in use will be rejected.
        </span>
      </div>
    </div>
  </div>

  <div class="flex gap-2 mt-6">
    <button vs-button appearance="outline" class="flex-1" type="button" (click)="cancel()" [disabled]="saving">
      Cancel
    </button>
    <button vs-button theme="primary" class="flex-1" type="button" [disabled]="!canSave" (click)="save()">
      <vs-icon slot="start" [class.animate-spin]="saving" [name]="saving ? 'refresh-cw-04' : 'save-01'"></vs-icon>
      {{ saving ? 'Saving...' : party ? 'Update' : 'Create' }}
    </button>
  </div>
</vs-dialog>
